import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { CommonMessageWidget } from '@eforall/common';
import { SelectEvent, TabStripModule } from '@progress/kendo-angular-layout';
import { environment } from '../../../../environments';
import { WebLinksPart } from '../../web-links/web-links.part';
import { EditModePersonTab, PersonDialogDataService } from '../person-dialog-data.service';
import { DemographicsPart } from './demographics/demographics.part';
import { EmailsPart } from './emails/emails.part';
import { BasicInfoPart } from './person-basic-info/person-basic-info.part';


@Component({
	selector: 'person-editor-view-part',
	standalone: true,
	imports: [
		TabStripModule,
		BasicInfoPart,
		EmailsPart,
		WebLinksPart,
		DemographicsPart,
		CommonMessageWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './person-editor.part.html'
})

export class PersonEditorViewPart implements OnInit {

	public personDialogDataService = inject(PersonDialogDataService);
	public personId = input.required<number>();

	public isNotProdEnvironment = environment.name !== 'PROD';

	ngOnInit() {
		// Clear cached person details before fetching new data
		this.personDialogDataService.personDetails.set(undefined);
		this.personDialogDataService.getPersonDetails(this.personId(), true);
	}

	private readonly TAB_INDEX_MAP: Record<number, EditModePersonTab> = {
		0: 'basicInfo',
		1: 'emails',
		2: 'webLinks',
		// 3: 'permissions',
		3: 'demographics'
	};

	onClickTab(event: SelectEvent): void {
		const tab = this.TAB_INDEX_MAP[event.index] ?? 'basicInfo';
		this.personDialogDataService.editModePersonTab.set(tab);
	}

}